var file_upload_viewer_default = {
  "fontElementMap": "P9qkY",
  "file_upload_container": "EbLQa",
  "file_upload_link": "_8SJ0z",
  "file_upload_error_container": "HlAlR",
  "file_upload_file_info": "zXqU1",
  "file_upload_type_icon": "_8kQM4",
  "file_upload_status_icon_container": "s5PnT",
  "file_upload_status_icon": "zKZI4",
  "file_upload_description": "NGjzl",
  "file_upload_name_container": "ANm4i",
  "file_upload_name": "RCHez",
  "file_upload_extension": "y4B93",
  "file_loader_icon": "Y-zLo",
  "file_upload_icon_frame": "iIPKq",
  "file_upload_icon_background": "ulDgj"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
